import * as React from "react"
import {
  SiteTransferActions,
  SiteTransferActionsProps,
} from "@modules/site/transfer/components/SiteTransferActions"

export function Transfer(props: SiteTransferActionsProps) {
  return <SiteTransferActions {...props} />
}
